"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Emoji = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Emoji = function Emoji(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16A8 8 0 108 0a8 8 0 000 16zm0-1.6A6.4 6.4 0 108 1.6a6.4 6.4 0 000 12.8z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.821 10.24a.666.666 0 01.939-.086l.004.004.03.023c.027.02.071.054.13.094.116.08.287.19.5.3.43.222.988.425 1.576.425.588 0 1.146-.203 1.577-.425a4.591 4.591 0 00.66-.417l.004-.005a.667.667 0 01.853 1.026l-.024.02-.052.04a5.93 5.93 0 01-.828.52c-.536.277-1.31.574-2.19.574-.879 0-1.654-.297-2.19-.574a5.927 5.927 0 01-.88-.56l-.023-.02a.667.667 0 01-.086-.94zm1.846-3.907a1 1 0 11-2 0 1 1 0 012 0zm3.667 1a1 1 0 100-2 1 1 0 000 2z",
    fill: "currentColor"
  }));
};

exports.Emoji = Emoji;
var _default = Emoji;
exports.default = _default;